const NowFound = () => {
    return (
        <div style={{ textAlign: "center" }}>
            <h1>404 Not Found.</h1>
            <p>
                トップページは<a href="/">こちら</a>
            </p>
        </div>
    );
};

export default NowFound;
